// const BASE_URL = 'https://api.spectrum.dev.stickboy.co/';
const BASE_URL = 'https://spectrum-backend.onrender.com';

export default {
  BASE_URL,
};
